import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  RouteComponentProps,
} from "react-router-dom";
import { Container } from "reactstrap";
import { Header } from "../shared/layout/Header";
import { IRoute } from "../shared/model/IRoute";
import routes from "./routes";

const AppRouter: React.FC = () => {
  return (
    <Container>
      <Router>
        <Header />
        <div>
          <Switch>
            {routes.map((route: IRoute, index: number) => {
              return (
                <Route
                  key={index}
                  path={route.path}
                  exact={route.exact}
                  render={(props: RouteComponentProps) => (
                    <route.component {...props} {...route.props} />
                  )}
                />
              );
            })}
            <Redirect to="/" />
          </Switch>
        </div>
      </Router>
    </Container>
  );
};
export default AppRouter;
